import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IBlood_Grp {
blood_grp_id:number,
blood_grp_name:string,
is_active:boolean
}

interface IBlood_GrpData {
    list?: Array<IBlood_Grp>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: IBlood_GrpData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const blood_grpSlice = createSlice({
    name: "blood_grp",
    initialState,
    reducers: {
        setBlood_GrpList: (state, _action: PayloadAction<IBlood_GrpData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetBlood_GrpToInit: (state) => {
            state = initialState;
        },
        setBlood_GrpMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setBlood_GrpList, resetBlood_GrpToInit, setBlood_GrpMessage } = blood_grpSlice.actions;

export default blood_grpSlice.reducer;

